"use client"

import { TableOfContents } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `TableOfContentsIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const TableOfContentsIcon = component(Icon)({ as: TableOfContents })
